"use strict";
import { TransactionStepType } from "features/transactions/steps/types";
export function createCollectFeesStep(txRequest) {
  return {
    type: TransactionStepType.CollectFeesTransactionStep,
    txRequest
  };
}
